<div class="container-fluid">
    <h2 mat-dialog-title>Clone Iteration - {{sourceIteration?.year}}</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <p class="text-muted">Create a new iteration based on {{sourceIteration?.year}}. Adjust details as needed.</p>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Year</mat-label>
                            <input required matInput name="year" id="year" type="number" formControlName="year"
                                [min]="2000" [max]="2100" />
                            <mat-error *ngIf="form.get('year').errors?.required">Year is required</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Entry Fee</mat-label>
                            <input required matInput name="entryFee" id="entryFee" type="number"
                                placeholder="0.00" formControlName="entryFee" [min]="0" step="0.01" />
                            <span matPrefix>$&nbsp;</span>
                            <mat-error *ngIf="form.get('entryFee').errors?.required">Entry Fee is required
                            </mat-error>
                            <mat-error *ngIf="form.get('entryFee').errors?.min">Entry Fee must be 0 or greater
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Start Date</mat-label>
                            <input required matInput [matDatepicker]="startPicker" formControlName="startDateOnly" />
                            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                            <mat-error *ngIf="form.get('startDateOnly').errors?.required">Start Date is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>End Date</mat-label>
                            <input required matInput [matDatepicker]="endPicker" formControlName="endDateOnly" />
                            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                            <mat-error *ngIf="form.get('endDateOnly').errors?.required">End Date is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Start Time</mat-label>
                            <input required matInput type="time" formControlName="startTimeOnly" />
                            <mat-error *ngIf="form.get('startTimeOnly').errors?.required">Start Time is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>End Time</mat-label>
                            <input required matInput type="time" formControlName="endTimeOnly" />
                            <mat-error *ngIf="form.get('endTimeOnly').errors?.required">End Time is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Notes</mat-label>
                            <textarea matInput name="notes" id="notes" placeholder="Notes (optional)" rows="3"
                                formControlName="notes"></textarea>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-12">
                        <mat-slide-toggle formControlName="copyMembers">
                            Copy Members from Source Iteration
                        </mat-slide-toggle>
                        <p class="text-muted small mt-2">Include all members from {{sourceIteration?.year}} in the new iteration</p>
                    </div>
                </div>
            </div>

            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading">Clone</button>
                <button mat-raised-button class="warning" type="button" (click)="dialogRef.close('cancel')" color="warn" [disabled]="isLoading">
                    Cancel
                </button>
            </div>
        </mat-dialog-actions>
    </form>
</div>

